export enum BrandID {
  NONE = 0,
  STANDARD = 71,
  CHALLENGE = 72,
  REVERSE_CHALLENGE = 73,
  GOLD = 88,
  TECHNOLOGY = 90,
  US_LONGTERM_CHALLENGE = 83,
  TECH_CHALLENGE = 468,
  REVERSE_TECH_CHALLENGE = 469,
  BTC = 600,
  ETH = 770,
  INVERSE_BTC = 771,
  INVERSE_ETH = 772,
  ALL = 'all',
}

export type CourseObject = {
  BRAND_ID: BrandID
  BRAND_CD: string
  BRAND_NM: string
  BRAND_NM_KANA: string
  SORT: number
  IMAGE_PATH: string
  MARKET_ID: number
  CURRENCY_CD: string
  AUTOSWEEP_SETED_FLG: number
  CHANGE_RATE?: string
}
